import React from 'react';
import { Layout } from 'react-admin';
import Menu from './Menu';
import AppBar from './AppBar';
import Sidebar from './Sidebar';
import { makeStyles } from '@material-ui/core/styles';
import { EditModeProvider } from '~/hooks/useEditModeContext';
import { ChangelogProvider } from '~/hooks/useChangelogContext';
import { DraftProvider } from '~/hooks/useDraftContext';
import { ApprovalCaseProvider } from '~/hooks/useApprovalCaseContext';
export default (props: any) => {
  const classes = useStyles();
  return (
    <EditModeProvider>
      <ChangelogProvider>
        <ApprovalCaseProvider>
          <DraftProvider>
            <Layout
              classes={{ content: classes.content }}
              {...props}
              sidebar={Sidebar}
              menu={Menu}
              appBar={AppBar}
            />
          </DraftProvider>
        </ApprovalCaseProvider>
      </ChangelogProvider>
    </EditModeProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  content: {
    paddingRight: theme.spacing(2),
  },
}));
